var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudentGroupSolid = function SvgStudentGroupSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M16.875 3.125H3.125a1.25 1.25 0 0 0-1.25 1.25v11.25a1.25 1.25 0 0 0 1.25 1.25h1.046a.63.63 0 0 0 .565-.357 3.75 3.75 0 0 1 6.778 0 .63.63 0 0 0 .565.357h4.796a1.25 1.25 0 0 0 1.25-1.25V4.375a1.25 1.25 0 0 0-1.25-1.25m-8.75 10a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m8.75 2.5h-4.42a5 5 0 0 0-1.028-1.25H15a.624.624 0 0 0 .625-.625v-7.5A.625.625 0 0 0 15 5.625H5a.625.625 0 0 0-.625.625v7.5a.625.625 0 0 0 .469.605 5 5 0 0 0-1.05 1.27h-.669V4.375h13.75z"
  })));
};
export default SvgStudentGroupSolid;